import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Help — contact and FAQ. */
export function HelpIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <circle cx="12" cy="12" r="8.4" />
      <path d="M9.6 9.4a2.6 2.6 0 0 1 5 .9c0 1.7-2.6 2-2.6 3.6" />
      <path d="M12 16.9h.01" />
    </PortalIcon>
  );
}
